import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { format } from "date-fns";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { quarterOptions, submitPlayersAndMatchData } from '../../redux/reducers/playersReducer';
import { handleNavigateStreamingOverlays } from '../../redux/actions/playerAction';
import { fetchEventStatusData } from '../../redux/actions/eventsAction';
import EventModal from './EventModal';
import ConfirmationModal from './ConfirmationModal';
import EventList from './EventList';
import EventGroupCheckboxes from './EventGroupCheckboxes';
import DateNavigation from './DateNavigation';
import SearchInput from './SearchInput';
import { setEventOptions } from '../../redux/reducers/settingReducer';
import { setConfirm, setEventListFilter, setEventModal, setIsMouseOverInput, setLoad, setLocationSearchText, setMergedEventData, setNextDay, setPreviousDay, setSearchText, setSelectedCheckboxes, setSelectedDate, setSelectedEventGroup, setSelectedGroups, setSelectedItems, setSelectedMonth, setSelectedMonthName, setSelectedYear, setSelectId, setShowWindow, setUserRole } from '../../redux/reducers/homeReducer';
import { fetchEvents } from '../../redux/thunks/fetchEvents';
import CustomDropdownRedux from '../../Component/CustomDropdown/CustomDropdownRedux';


const Home = () => {

  const {
    load,
    isMouseOverInput,
    eventModal,
    selectedDate,
    selectedMonthName,
    selectedYear,
    showWindow,
    selectId,
    reLoadData,
    locationSearchText,
    selectedCheckboxes,
    searchText,
    selectedGroups,
    userRole,
    mergedEventData,
    eventList,
    fetchEventsLoading,
    eventListFilter,
    fetchEventsError

  } = useSelector((state) => state?.home);
  const selectedMonth = useSelector((state) => state?.home?.selectedMonth); // Use Redux state
  const { matchStatusDropdown,eventGroupDropdown } = useSelector((state) => state?.dropdown?.dropdowns);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");

  // Calendar sidebar toggle — collapsed by default so event list is primary
  const [showCalendar, setShowCalendar] = useState(false);


  const fullDayName = selectedDate?.toLocaleDateString("en-US", { weekday: "long" });
  const formattedDate = `${selectedDate?.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}`;

  const toggleSelectAll = () => {
    if (selectedGroups.length == filteredData.length) {
      dispatch(setSelectedGroups([]));
    } else {
      dispatch(setSelectedGroups(filteredData.map((group) => group.event_group_name)));
    }
  };

  const selectAll = () => {
    const allSelected = eventList.reduce((acc, item) => {
      acc[item.event_group_name] = true;
      return acc;
    }, {});
    dispatch(setSelectedCheckboxes(allSelected));
  };



  useEffect(() => {
    if (eventList?.length) {
      // Always select all groups when event list changes (e.g. month navigation)
      dispatch(setLoad(true));
      dispatch(setSelectedGroups(filteredData.map((group) => group.event_group_name)));
    }
  }, [eventList]);


  const unselectAll = () => {
    dispatch(setSelectedGroups([]));
  };

  let uniqueEventGroupNames = new Set();

  const filteredUniqueEventGroup = eventList?.length && eventList?.length > 0 ? eventList.filter((item) => {
    const eventName = item?.event_group_name?.toLowerCase();
    if (!uniqueEventGroupNames.has(eventName)) {
      uniqueEventGroupNames.add(eventName);
      return true;
    } else {
      return false;
    }
  }) : [];

  const filteredData = filteredUniqueEventGroup.filter((item) => {

    const searchLower = searchText.toLowerCase();
    const nameMatch = item.event_group_name.toLowerCase().includes(searchLower);
    const idMatch = searchLower.startsWith('gc') ?
      item.event_group_id.toString() === searchLower.substring(2) :
      item.event_group_id.toString().includes(searchLower);
    return nameMatch || idMatch;
  });

  const filteredDataDropDown = [
    { value: "All", label: "All" },
    ...filteredData
      .sort((a, b) => b.event_group_id - a.event_group_id)
      .map((item) => ({
        value: `GC${item.event_group_id} ${item.event_group_name}`,
        label: `GC${item.event_group_id} ${item.event_group_name}`
      }))
  ];


  const handleConfirm = (window, confirm, data) => {
    dispatch(setShowWindow(window));
    dispatch(setConfirm(confirm));
    if (data) {
      handleMatchStatus(data);
    }
  };

  const { eventStatusData, matchStatusOptions, loading } = useSelector((state) => state.eventsReducer);

  useEffect(() => {
    dispatch(fetchEventStatusData(token));
  }, [dispatch, token,selectedMonthName, selectedYear]);

  useEffect(() => {
    if (token) {
      dispatch(fetchEvents(token));
    }
  }, [dispatch, token,selectedMonthName, selectedYear]);
  useEffect(() => {
    const newSelectedItems = Object.keys(selectedCheckboxes).filter(
      (key) => selectedCheckboxes[key]
    );
    dispatch(setSelectedItems(newSelectedItems));
  }, [selectedCheckboxes]);

  useEffect(() => {
    if (eventList?.length > 0) {
      const mergedData = eventList.map(event => {
        const matchedStatus = eventStatusData?.find(status => status.event_code == event.event_code);
        return {
          ...event,
          status_work_fsp: matchedStatus ? matchedStatus.status_work_fsp : null,
          status_id: matchedStatus ? matchedStatus.id : null,
          photographer_fsp_id: matchedStatus ? matchedStatus.photographer_fsp_id : null,
        };
      });
      dispatch(setMergedEventData(mergedData));
    }
  }, [eventStatusData, eventList, reLoadData]);


  const filteredMatchData = eventListFilter.filter((match) => {
    const matchStatusCondition = !matchStatusDropdown || matchStatusDropdown == "All" || match.status_work_fsp == matchStatusDropdown || match.status_id == matchStatusDropdown;
    const userRoleCondition = userRole == "All" || match.userRole == userRole;
    const locationCondition = locationSearchText == "" || match.event_group_location?.toLowerCase().includes(locationSearchText.toLowerCase());
    const groupCondition = selectedGroups.includes(match.event_group_name);
    return matchStatusCondition && userRoleCondition && locationCondition && groupCondition;
  });

  const searchFilterMatchData = mergedEventData.filter((match) => {
    const locationCondition =
      locationSearchText === "" ||
      (match.event_name?.toLowerCase() || '').includes(locationSearchText.toLowerCase()) ||
      (match.event_code?.toLowerCase() || '').includes(locationSearchText.toLowerCase()) ||
      (match.event_code?.toLowerCase() || '').includes(locationSearchText.toLowerCase()) ||
      (match.event_group_id?.toString()?.toLowerCase() || '').includes(locationSearchText.toLowerCase()) ||
      (match.event_group_id?.toString()?.toLowerCase() || '').includes(locationSearchText.toLowerCase().replace('gc', '')) ||
      (match.team_a_code?.toString()?.toLowerCase() || '').includes(locationSearchText.toLowerCase()) ||
      (match.team_a_name?.toString()?.toLowerCase() || '').includes(locationSearchText.toLowerCase()) ||
      (match.team_b_code?.toString()?.toLowerCase() || '').includes(locationSearchText.toLowerCase()) ||
      (match.team_b_name?.toLowerCase() || '').includes(locationSearchText.toLowerCase()) ||
      (match.event_group_name?.toLowerCase() || '').includes(locationSearchText.toLowerCase());


    const matchStatusCondition = !matchStatusDropdown || matchStatusDropdown == "All" || match.status_work_fsp == matchStatusDropdown || match.status_id == matchStatusDropdown;

const splitValue = eventGroupDropdown ? eventGroupDropdown.split(" ") : [];
const matchResult = splitValue.length > 0 ? splitValue[0].match(/\d+/) : null;
const groupName = matchResult ? matchResult[0] : null;
    const eventGroupFilter = groupName == 'All' || !groupName ||  (match.event_group_id && match.event_group_id == groupName);


    return locationCondition && eventGroupFilter && matchStatusCondition;
  });

  let eventMatchData = isMouseOverInput ? searchFilterMatchData : filteredMatchData;

  // Always group events by date for the list view (upcoming first)
  const eventsByDate = eventMatchData.reduce((acc, match) => {
    const eventDate = new Date(match.event_date_start).toDateString();
    if (!acc[eventDate]) {
      acc[eventDate] = [];
    }
    acc[eventDate].push(match);
    return acc;
  }, {});

  const sortedEvents = Object.entries(eventsByDate).sort((a, b) => new Date(b[0]) - new Date(a[0]));

  useEffect(() => {
    if (selectedDate) {
      let dateToUse = selectedDate instanceof Date ? selectedDate : new Date(selectedDate);

      if (!isNaN(dateToUse.getTime())) {
        let filteredData = mergedEventData.filter((item) => item?.event_date_start == format(dateToUse, "yyyy-MM-dd"));
        dispatch(setEventListFilter(filteredData));
      } else {
        console.error("Invalid date value:", selectedDate);
      }
    } else {
      // No date selected — show all events
      dispatch(setEventListFilter(mergedEventData));
    }
  }, [selectedDate, mergedEventData]);

  const handleDateSelect = (date) => {

    if (date === null || date === undefined) {
      dispatch(setSelectedDate(null));
    } else if (date instanceof Date && !isNaN(date)) {
      if (selectedDate && date.toDateString() === selectedDate.toDateString()) {
        dispatch(setSelectedDate(null)); // Deselect if the same date is selected
      } else {
        dispatch(setSelectedDate(date));
      }
    } else {
      console.error("Invalid date selected:", date);
    }
  };

  const handleClearDateFilter = () => {
    dispatch(setSelectedDate(null));
  };

  const handleGroupCheckboxChange = (checked, groupName) => {
    if (checked) {
      dispatch(setSelectedGroups([...selectedGroups, groupName]));
    } else {
      dispatch(setSelectedGroups(selectedGroups.filter((group) => group !== groupName)));
    }
  };

  const userRoleOptions = [
    { value: "All", label: "All" },
    { value: "Stat Scorer", label: "Stat Scorer" },
    { value: "Stat Caller", label: "Stat Caller" },
    { value: "Stat Reviewer", label: "Stat Reviewer" },
  ];

  const handleUserRole = (userID) => {
    dispatch(setUserRole(userID));
  };

  const handleEventGroup = (value) => {

    const splitValue = value.split(" ");
    const groupName = splitValue.length > 1 ? splitValue.slice(1).join(" ") : value;
    dispatch(setSelectedEventGroup(groupName));
  };

  const handleNavigateHistoryPage = (id) => {
    localStorage.setItem("eventID", id);
    navigate('/game-logs');
  };

  const handleOverlay = (event_id, event_code, team_a_name, team_b_name) => {
    dispatch(handleNavigateStreamingOverlays(
      event_code,
      team_a_name,
      team_b_name,
      event_id,
      event_code,
      navigate
    ));
  };

  const previousDay = () => {
    dispatch(setPreviousDay())
  };

  const nextDay = () => {
    dispatch(setNextDay())
  };

  const handleMonthChange = (date) => {

    localStorage.setItem("selectedMonth", date.toISOString());
    dispatch(setSelectedMonth(date));

    if (date === null || date === undefined) {
      dispatch(setSelectedDate(null));
    } else if (date instanceof Date && !isNaN(date)) {
      if (selectedDate && date.toDateString() === selectedDate.toDateString()) {
        dispatch(setSelectedDate(null));
      } else {
        dispatch(setSelectedDate(date));
        dispatch(setSelectedMonthName(date.getMonth() + 1));
        dispatch(setSelectedYear(date.getFullYear()));
        dispatch(setLoad(false));

      }
    } else {
      console.error("Invalid date selected:", date);
    }
  };
  useEffect(() => {
    dispatch(submitPlayersAndMatchData({}))
    localStorage.setItem("event_id", '')
    localStorage.setItem("eventID", '')
  }, [])
  return (
    <div className="w-full mx-auto mt-[28px] relative">
      {/* Top bar: Search + Calendar toggle */}
      <div className={`max-w-[1512px] w-full mx-auto px-6 md:px-6 lg:px-12 flex flex-row justify-between items-center ${isMouseOverInput ? "pb-0" : "pb-[26px]"}`}>
        {!isMouseOverInput && (
          <div className="flex items-center gap-3">
            {/* Calendar toggle button */}
            <button
              onClick={() => setShowCalendar(!showCalendar)}
              className="flex items-center gap-2 px-3 py-2 rounded border border-[#ABABAB] hover:bg-[#F5F5F5] transition-colors"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="4" width="16" height="14" rx="2" stroke="#4A4A4A" strokeWidth="1.5"/>
                <path d="M2 8H18" stroke="#4A4A4A" strokeWidth="1.5"/>
                <path d="M6 2V6" stroke="#4A4A4A" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M14 2V6" stroke="#4A4A4A" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <span className="font-montserrat text-sm font-medium text-[#4A4A4A] hidden sm:inline">
                {showCalendar ? 'Hide Calendar' : 'Calendar'}
              </span>
            </button>
            {/* Date filter indicator */}
            {selectedDate && (
              <DateNavigation
                previousDay={previousDay}
                nextDay={nextDay}
                formattedDate={formattedDate}
              />
            )}
            {selectedDate && (
              <button
                onClick={handleClearDateFilter}
                className="px-3 py-2 rounded bg-[#A57C52] text-white font-montserrat text-xs font-medium hover:bg-[#8B6842] transition-colors"
              >
                Show All
              </button>
            )}
          </div>
        )}
        <SearchInput searchText={locationSearchText} setSearchText={(e) => dispatch(setLocationSearchText(e))} isMouseOverInput={isMouseOverInput} setIsMouseOverInput={setIsMouseOverInput} />
      </div>
      <div className="bg-[#E8E8E8] h-[1px] w-full"></div>
      <div className="max-w-[1512px] w-full mx-auto flex md:flex-row flex-col px-6 md:px-6 lg:px-12 relative">
        {/* Collapsible calendar sidebar */}
        {showCalendar && !isMouseOverInput && (
          <div className="min-w-[272px] max-w-full md:max-w-[456px] flex-shrink-0 pb-4 md:pb-10 border-r-none md:border-r-[1px] border-[#E8E8E8] pt-0 pr-0 sm:pr-3">
            <div>
              <DayPicker
                mode="single"
                selected={selectedDate}
                onSelect={handleDateSelect}
                month={selectedMonth}
                onMonthChange={handleMonthChange}
                modifiers={{
                  hasEvent: mergedEventData.map(event => new Date(event.event_date_start))
                }}
                modifiersClassNames={{
                  hasEvent: "has-event"
                }}
              />
            </div>
            <EventGroupCheckboxes
              filteredData={filteredData}
              selectedGroups={selectedGroups}
              handleGroupCheckboxChange={handleGroupCheckboxChange}
              toggleSelectAll={toggleSelectAll}
              unselectAll={unselectAll}
              selectAll={selectAll}
              searchText={searchText}
              setSearchText={(e) => dispatch(setSearchText(e))}
            />
          </div>
        )}
        {/* Event list — full width when calendar is hidden */}
        <div className={`pl-0 ${showCalendar && !isMouseOverInput ? 'md:pl-6' : ''} py-6 w-full`}>
          {/* Filters row */}
          <div className={`md:flex-row flex-col gap-4 md:gap-0 justify-start items-start md:justify-between md:items-center w-full pb-6 border-[#E8E8E8] border-b-[1px] ${isMouseOverInput ? "hidden" : "flex"}`}>
            <div className="flex items-center gap-3">
              {eventMatchData?.length > 0 ? (
                <p className="bg-primary rounded flex justify-center items-center text-light text-xl w-max px-4 h-10">
                  {eventMatchData?.length}
                </p>
              ) : (
                <p className="bg-primary rounded flex justify-center items-center text-light text-xl w-max px-4 h-10">
                  {eventMatchData?.length}
                </p>
              )}
              <p className="text-base text-accent font-medium font-montserrat">
                {selectedDate ? fullDayName : 'All Events'}
              </p>
            </div>
            <div className={`flex flex-col sm:flex-row items-center gap-4 max-w-full w-full justify-start md:justify-end ${isMouseOverInput ? 'md:max-w-[780px]' : 'md:max-w-[530px]'}`}>
              {isMouseOverInput && (
                <CustomDropdownRedux
                  id="eventGroupDropdown"
                  customStyle={`bg-transparent font-montserrat text-base text-[#4A4A4A] h-12 rounded border-[#ABABAB] border-[1px] rounded cursor-pointer w-full flex justify-between px-4 py-3 items-center`}
                  customStyleDropdownList={`font-montserrat font-medium absolute bg-white rounded-md shadow-md w-full mt-3 p-4`}
                  liCustomStyle={`cursor-pointer py-2 font-medium text-[#4A4A4A] hover:font-semibold w-full`}
                  dropdownContainer="max-w-full sm:max-w-[280px] w-full"
                  options={filteredDataDropDown}
                  onChange={handleEventGroup}
                />
              )}
              <CustomDropdownRedux
                id="userRoleDropdown"
                customStyle={`bg-transparent font-montserrat text-base text-[#4A4A4A] h-12 rounded border-[#ABABAB] border-[1px] rounded cursor-pointer w-full flex justify-between px-4 py-3 items-center`}
                customStyleDropdownList={`font-montserrat font-medium absolute bg-white rounded-md shadow-md w-full mt-3 p-4`}
                liCustomStyle={`cursor-pointer py-2 font-medium text-[#4A4A4A] hover:font-semibold w-full`}
                dropdownContainer="max-w-full sm:max-w-[185px] w-full"
                options={userRoleOptions}
                onChange={handleUserRole}
              />
              <CustomDropdownRedux
                id="matchStatusDropdown"
                customStyle={`bg-transparent font-montserrat text-base text-[#4A4A4A] h-12 rounded border-[#ABABAB] border-[1px] rounded cursor-pointer w-full flex justify-between px-4 py-3 items-center`}
                customStyleDropdownList={`font-montserrat font-medium absolute bg-white rounded-md shadow-md w-full mt-3 p-4 `}
                liCustomStyle={`cursor-pointer py-2 font-medium text-[#4A4A4A] hover:font-semibold w-full`}
                dropdownContainer="max-w-full sm:max-w-[270px] w-full"
                options={matchStatusOptions}
              />
            </div>
          </div>
          {/* Event list content */}
          {!eventMatchData && (loading || fetchEventsLoading) ? (
            <div className='font-bebas min-h-screen text-4xl flex justify-center items-center'>
              {(loading || fetchEventsLoading) && (!eventList?.length || eventList?.length === 0) && 'Loading...'}
              {!(loading || fetchEventsLoading) && (!eventList?.length || eventList?.length === 0) && 'No Data'}
            </div>
          ) : (
            <>
              {eventMatchData?.length > 0 ? (
                <EventList
                  eventMatchData={eventMatchData}
                  handleOverlay={handleOverlay}
                  handleNavigateHistoryPage={handleNavigateHistoryPage}
                  reLoadData={reLoadData}
                  sortedEvents={sortedEvents}
                  isMouseOverInput={isMouseOverInput}
                  showDateHeaders={!selectedDate}
                  setShowWindow={(val) => dispatch(setShowWindow(val))}
                  setSelectId={(val) => dispatch(setSelectId(val))}
                />
              ) : (
                <div className='flex justify-center items-center py-20'>
                  {isMouseOverInput ? (
                    <p className='text-sm md:text-2xl leading-tight max-w-[220px] md:max-w-[420px] text-white bg-primary rounded p-2 shadow-2xl'>
                      The data you are searching for is not available, please try again.
                    </p>
                  ) : (
                    <div>
                      {fetchEventsError ? (
                        <p className='text-sm md:text-2xl leading-tight max-w-[220px] md:max-w-[400px] text-white bg-primary rounded p-2'>{fetchEventsError}</p>
                      ) : (
                        <p className='text-sm md:text-2xl leading-tight max-w-[220px] md:max-w-[400px] text-white bg-primary rounded p-2'>
                          {loading || fetchEventsLoading
                            ? 'Loading...'
                            : eventList?.length === 0
                              ? 'No events assigned to you this month.'
                              : 'No matching events. Try adjusting your filters.'}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <EventModal eventModal={eventModal} setEventModal={setEventModal} />

      <ConfirmationModal
        showWindow={showWindow}
        handleConfirm={handleConfirm}
        selectId={selectId} />
    </div>
  );
};

export default Home;
